import axios from "../http";

const request = {
    getWxOpenId(data = {}) {
        let url = 'weixin.get.openid';
        return axios.request({
            url,
            data
        })
    },
    getMemberInfo(data = {}) {
        let url = 'member.info.get';
        return axios.request({
            url,
            data
        })
    }
};

export default request;
